/**
 * Lightweight auth event bus via window CustomEvent.
 * Services fire notifyAuthFailure() on 401; AuthContext listens and
 * starts the reconnect loop without needing direct imports.
 */
export const AUTH_UNAUTHORIZED_EVENT = 'auth:unauthorized';

export function notifyAuthFailure() {
  window.dispatchEvent(new CustomEvent(AUTH_UNAUTHORIZED_EVENT));
}
